export var ConnectionTypes;
(function (ConnectionTypes) {
    ConnectionTypes["CHOREO_SERVICE"] = "CHOREO_SERVICE";
    ConnectionTypes["CHOREO_DATABASE"] = "DATABASE";
    ConnectionTypes["THIRD_PARTY_SERVICE"] = "THIRD_PARTY_SERVICE";
    ConnectionTypes["CHOREO_CONFIGURATION_GROUP"] = "CHOREO_CONFIGURATION_GROUP";
})(ConnectionTypes || (ConnectionTypes = {}));
